<template>
  <el-popover
    v-model="visible"
    :placement="placement"
    :width="width"
    :trigger="trigger"
    :popper-class="popoverClassName"
    :visible-arrow="false"
    @show="emitVisibleChange(true)"
    @hide="emitVisibleChange(false)"
  >
    <div slot="reference" class="company-switcher-reference" :class="referenceClass">
      <slot name="reference">
        <span>{{ companyName }}</span>
      </slot>
    </div>

    <div class="company-switcher-panel" :class="panelClassName">
      <div class="company-switcher-search" @click.stop @mousedown.stop>
        <el-input
          :value="searchName"
          size="small"
          clearable
          prefix-icon="el-icon-search"
          :placeholder="placeholder"
          @input="handleSearchInput"
          @clear="handleSearchClear"
        />
      </div>

      <div class="company-switcher-list" :class="listClassName">
        <button
          v-for="(item, index) in companyData"
          :key="item.company_id || index"
          type="button"
          class="company-switcher-item"
          @click="handleSelect(item)"
        >
          {{ item.company_name }}
        </button>
        <div v-if="!companyData || !companyData.length" class="company-switcher-empty">
          {{ emptyText }}
        </div>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'CompanySwitcherPopover',
  props: {
    companyName: {
      type: String,
      default: ''
    },
    companyData: {
      type: Array,
      default: () => []
    },
    searchName: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '搜索企业名称'
    },
    emptyText: {
      type: String,
      default: '暂无企业'
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    width: {
      type: [String, Number],
      default: 360
    },
    theme: {
      type: String,
      default: 'admin'
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    popoverClassName() {
      return this.theme === 'screen'
        ? 'company-switcher-popper company-switcher-popper--screen'
        : 'company-switcher-popper company-switcher-popper--admin';
    },
    panelClassName() {
      return this.theme === 'screen'
        ? 'company-switcher-panel--screen'
        : 'company-switcher-panel--admin';
    },
    listClassName() {
      return this.theme === 'screen'
        ? 'company-switcher-list--screen'
        : 'company-switcher-list--admin';
    },
    referenceClass() {
      return this.theme === 'screen'
        ? 'company-switcher-reference--screen'
        : 'company-switcher-reference--admin';
    }
  },
  methods: {
    handleSearchInput(value) {
      this.visible = true;
      this.$emit('search', value);
    },
    handleSearchClear() {
      this.visible = true;
      this.$emit('search', '');
    },
    handleSelect(item) {
      this.visible = false;
      this.$emit('select', item);
    },
    emitVisibleChange(visible) {
      this.$emit('visible-change', visible);
    }
  }
};
</script>

<style lang="scss">
.company-switcher-popper {
  padding: 0;
  border: 1px solid rgba(133, 149, 173, 0.22);
  border-radius: 12px;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.16);
  overflow: hidden;
}

.company-switcher-popper--admin {
  min-width: 360px;
}

.company-switcher-popper--screen {
  min-width: 360px;
  border: 1px solid rgba(102, 208, 255, 0.35);
  background: rgba(8, 16, 36, 0.78);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow:
    0 0 0 1px rgba(102, 208, 255, 0.12) inset,
    0 0 24px rgba(102, 208, 255, 0.22),
    0 20px 48px rgba(0, 0, 0, 0.55);
}

.company-switcher-reference {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.company-switcher-reference--admin {
  color: inherit;
}

.company-switcher-reference--screen {
  color: #fff;
}

.company-switcher-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.company-switcher-panel--admin {
  background: #fff;
}

.company-switcher-panel--screen {
  background: linear-gradient(180deg, rgba(10, 20, 44, 0.92) 0%, rgba(6, 12, 30, 0.92) 100%);
}

.company-switcher-search {
  padding: 14px 14px 10px;
}

.company-switcher-search .el-input__inner {
  border-radius: 10px;
}

.company-switcher-panel--screen .company-switcher-search .el-input__inner {
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(102, 208, 255, 0.28);
  color: #f3f6fb;
  border-radius: 10px;
  transition: all .2s ease;
}

.company-switcher-panel--screen .company-switcher-search .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.42);
}

.company-switcher-panel--screen .company-switcher-search .el-input__inner:focus {
  background-color: rgba(255, 255, 255, 0.09);
  border-color: #4facfe;
  box-shadow: 0 0 0 3px rgba(79, 172, 254, 0.18);
  color: #ffffff;
}

.company-switcher-panel--screen .company-switcher-search .el-input__prefix {
  color: rgba(102, 208, 255, 0.65);
}

.company-switcher-list {
  overflow-y: auto;
  max-height: 260px;
  padding: 0 10px 12px;
}

.company-switcher-list::-webkit-scrollbar {
  width: 6px;
}

.company-switcher-list::-webkit-scrollbar-track {
  background: transparent;
}

.company-switcher-list::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.55);
}

.company-switcher-list--screen::-webkit-scrollbar {
  width: 6px;
}

.company-switcher-list--screen::-webkit-scrollbar-track {
  background: transparent;
}

.company-switcher-list--screen::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(102, 208, 255, 0.55), rgba(79, 172, 254, 0.45));
  box-shadow: 0 0 8px rgba(102, 208, 255, 0.35);
}

.company-switcher-list--screen::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(102, 208, 255, 0.75), rgba(79, 172, 254, 0.65));
}

.company-switcher-item {
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 42px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  outline: none;
  transition: background-color .18s ease, color .18s ease, transform .18s ease;
}

.company-switcher-item:hover {
  background: rgba(64, 158, 255, 0.10);
}

.company-switcher-list--screen .company-switcher-item {
  color: #cfe5ff;
  border-left: 2px solid transparent;
  border-radius: 8px;
  padding-left: 12px;
}

.company-switcher-list--screen .company-switcher-item:hover {
  background: linear-gradient(90deg, rgba(79, 172, 254, 0.22) 0%, rgba(79, 172, 254, 0.06) 80%);
  color: #ffffff;
  border-left-color: #4facfe;
  box-shadow:
    0 0 0 1px rgba(79, 172, 254, 0.25),
    0 10px 20px -10px rgba(79, 172, 254, 0.35);
  transform: translateX(1px);
}

.company-switcher-empty {
  padding: 18px 12px 16px;
  font-size: 13px;
  text-align: center;
  color: #94a3b8;
}

.company-switcher-list--screen .company-switcher-empty {
  color: rgba(255, 255, 255, 0.52);
}
</style>
